import React, { Component, PropTypes } from 'react';
import { replace } from 'redux-router';
import { accountRoute } from '../../routes';

import connect from '../../utils/connect';
import {
	redirectToPathIf,
	ROLE_JUDGE,
	ROLE_JUDGE_FOTD,
	ROLE_JUDGE_FOTM,
	ROLE_JUDGE_FOTY,
	ROLE_JUDGE_TCEA,
} from '../../utils/authorization';
//import translate from '../../utils/translate';

//import * as actions from '../../actions/account';

import css from './jury.scss';

class AccountJury extends Component {
	static propTypes = {
		users: PropTypes.object.isRequired,
		dispatch: PropTypes.func.isRequired,
		children: PropTypes.any,
	};

	constructor(props) {
		super();

		this.state = {
			waiting: true,
			showScorecard: false,
		};
	}

	componentWillMount() {
		const isLoggedIn = this.props.users.isLoggedIn();
		const hasAccess = !this.props.users.canHas([
			ROLE_JUDGE_FOTD,
			ROLE_JUDGE_FOTM,
			ROLE_JUDGE_FOTY,
			ROLE_JUDGE_TCEA,
		]);

		redirectToPathIf(
			this.props.dispatch,
			accountRoute(isLoggedIn ? '' : '/login'),
			hasAccess,
			accountRoute('/jury')
		);


		this.redirectToAwardCategory(this.props);
	}

	componentWillReceiveProps(nextProps) {
		this.redirectToAwardCategory(nextProps);
	}

	render() {
		return (
			<div className='account-jury'>
				{this.props.children}
			</div>
		);
	}

	redirectToAwardCategory(props) {
		const currentRoute = props.router.routes[props.router.routes.length - 1];
		switch (currentRoute.path) {
			case 'fotd':
			case 'fotm':
			case 'foty':
			case 'tcea':
				break;
			default:
				if (props.users.canHas([ROLE_JUDGE_FOTD])) {
					props.dispatch(replace(accountRoute('/jury/fotd')));
				} else if (props.users.canHas([ROLE_JUDGE_FOTM])) {
					props.dispatch(replace(accountRoute('/jury/fotm')));
				} else if (props.users.canHas([ROLE_JUDGE_FOTY])) {
					props.dispatch(replace(accountRoute('/jury/foty')));
				} else if (props.users.canHas([ROLE_JUDGE_TCEA])) {
					props.dispatch(replace(accountRoute('/jury/tcea')));
				}
		}
	}
}

export default connect(AccountJury);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury.js
 **/